import React, { useState } from 'react';
import "../../../assets/css/wishlist.css";
import { FaGift } from 'react-icons/fa';
// import "../../../assets/css/style.css";
import { useSelector, useDispatch } from 'react-redux';
import { checkSessionValidity, getSampleCurrencyFormat } from "../../../utils/utils";
import { GET_CUSTOMER_CART, APPLY_COUPONS, REMOVE_COUPONS_CART,CUSTOMER_CART } from '../../../assets/graphql';
import { saveaddtoproductcart,savecustomerresult } from '../../../features/HomePageSlice/homeDataSlice';
import { apiHandler } from "../../../api";
import { endpoint } from "../../../api/endpoint";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

const CartRightBlock = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginUser = localStorage.getItem("loginURL");

    const [couponCode, setCouponCode] = useState("");
    const [applyCouponCart, setApplyCoupanCart] = useState({})
    const [loader, setLoader] = useState(false);
    const [invalidCoupan, setInvalidCoupan]=useState("");
    const { addtoproductcart, customerresult, appliedCoupon, cartPrices,shippingAddresses, landingData } = useSelector(
        (state) => state.home
    );
  console.log(addtoproductcart, "add")
  console.log(cartPrices, "this")
    const { token } = useSelector((state) => state.login);

    const getLatestCartInfo = async () => {
        if (token) {
            // setLoader(true);
          
            const result = await apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                authToken: token,
                data: {
                    base_url: endpoint.API_BASE_URL,
                    query: GET_CUSTOMER_CART,
                    variables: { cart_id: customerresult.id },
                },
            });
            
            checkSessionValidity(result.data, dispatch);
            // setLoader(false);
            if (!result.data.message) {

                dispatch(
                    saveaddtoproductcart(result.data.cart)
                );
           

            }
            else if (result.data.message && result.data.message.data && result.data.message.data.cart) {
                dispatch(
                    saveaddtoproductcart(result.data.message.data.cart)
                );
            } else {
                const customerresult = await apiHandler({
                    url: endpoint.GRAPHQL_URL,
                    method: 'POST',
                    authToken: token,
                    data: {
                        base_url: endpoint.API_BASE_URL,
                        query: CUSTOMER_CART,
                        variables: {},
                    },
                });
                
                checkSessionValidity(customerresult.data, dispatch);
                if (!customerresult.data.error_code) {
                    dispatch(savecustomerresult(customerresult.data.customerCart));
                    // getLatestCartInfo(customerresult.data.customerCart.id);
                }
            }
        } else {
            
            if(loginUser) {
                navigate(`/${loginUser}`)
            } else {
                navigate("/default");
            }
            // navigate('/default');
        }
    };
    const ApplyCoupons = async () => {
        if (token) {
            // setLoader(true);
            const result = await apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                authToken: token,
                data: {
                    "base_url": endpoint.API_BASE_URL,
                    "variables": {
                        coupon_code: couponCode,
                        cart_id: customerresult.id
                    },
                    "query": APPLY_COUPONS
                },
            });
            checkSessionValidity(result.data, dispatch);
            // setLoader(false);
            if(!result.data.message)
            {
            setApplyCoupanCart(result.data.applyCouponToCart.cart);
        
            getLatestCartInfo();
            toast.success("coupan card added successfully");
            }else{
                setInvalidCoupan("Invalid coupon ");
                // toast.error("The coupon code isn't valid. Verify the code and try again");
            }
        }

        else {
            if(loginUser) {
                navigate(`/${loginUser}`)
            } else {
                navigate("/default");
            }
            // navigate('/default');
        }
    };

    const removeCouponFromCart = async () => {
        if (token) {
            // setLoader(true);
            const result = await apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                authToken: token,
                data: {
                    "base_url": endpoint.API_BASE_URL,
                    "variables": {
                        cart_id: customerresult.id
                    },
                    "query": REMOVE_COUPONS_CART
                },
            });
            checkSessionValidity(result.data, dispatch);
            // setLoader(false);
            getLatestCartInfo();
             setCouponCode("");
        }
        else {
            if(loginUser) {
                navigate(`/${loginUser}`)
            } else {
                navigate("/default");
            }
            // navigate('/default');
        }
    };


    const getTotaltDiscount = () => {
        let totalPrice = 0;
        addtoproductcart && addtoproductcart.forEach(element => {
            const value = element && element.product && element.product.price_range && element.product.price_range.minimum_price && element.product.price_range.minimum_price.discount && element.product.price_range.minimum_price.discount.amount_off ? element.product.price_range.minimum_price.discount.amount_off : 0;
                const qty = element && element.quantity ? element.quantity : 0;
            totalPrice = totalPrice + (qty * value);
        });
        return addtoproductcart[0] ? getSampleCurrencyFormat("INR", totalPrice) : "0.00";
    };
    const getTotalAmount = () => {
        let totalPrice = 0;
        addtoproductcart && addtoproductcart.forEach(element => {
            const value = element && element.product && element.product.price_range && element.product.price_range.minimum_price && element.product.price_range.minimum_price.regular_price && element.product.price_range.minimum_price.regular_price.value ? element.product.price_range.minimum_price.regular_price.value : 0;
                const qty = element && element.quantity ? element.quantity : 0;
            totalPrice = totalPrice + (qty * value);
        });
        return addtoproductcart[0] ? getSampleCurrencyFormat("INR", totalPrice) : "0.00";
    };

  const countItemsInCart = () => {
    const totalQty = addtoproductcart.reduce((totalQty, element) => {
        const qty = element && element.quantity ? element.quantity : 0;
        return totalQty + qty;
    }, 0);
if (totalQty==1){
    return;
}
    return '(' + totalQty + ' items)';
};

    


    const getProductDiscount = () => {
        let totalDiscount = 0;
        cartPrices && cartPrices.discounts && cartPrices.discounts.forEach(element => {
            const value = element && element.amount && element.amount.value ? element && element.amount && element.amount.value : 0;
            totalDiscount = value;
        });

        return getSampleCurrencyFormat("INR", totalDiscount);

    }
    const getShippingAmount = () => {
        let shipping = 0;
        shippingAddresses && shippingAddresses.forEach(shipping_amount => {
            shipping = shipping_amount && shipping_amount.selected_shipping_method && shipping_amount.selected_shipping_method.amount && shipping_amount.selected_shipping_method.amount.value ? shipping_amount && shipping_amount.selected_shipping_method && shipping_amount.selected_shipping_method.amount && shipping_amount.selected_shipping_method.amount.value : 0;
        });
        return getSampleCurrencyFormat("INR",  shipping);
    }
    const resendhandleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            ApplyCoupons();
        }
    }
    const errorCheckout=()=>{
        let inactiveProduct = false;
        addtoproductcart && addtoproductcart.forEach(cartitem => {
          if (cartitem && cartitem.errors && cartitem.errors[0] && cartitem.errors[0].code && cartitem.errors[0].code === 'ITEM_QTY')
          {
            inactiveProduct = true;
          }
        });
        if (inactiveProduct) {
            toast.error("Please remove Out of Stock item");
        } else {
            navigate('/checkout');
        }
    };
    return (
        <>
            <div className="cart_right_block">

                <div className="coupon_option">
                    {appliedCoupon && appliedCoupon[0] && appliedCoupon[0].code ? (
                        <>
                          <div className='couponappliedblock'>
                            <label><img src="img/coupon.jpg" alt="" />Coupon applied</label>
                            <label for="">{appliedCoupon[0].code}</label>
                            <button className="couponCheck" onClick={() => removeCouponFromCart()}>Remove</button>
                          </div>
                        </>
                    ) : (
                        <>
                   
                            <label><img src="img/coupon.jpg" alt="" />Apply Coupon</label>
                            <div className='Discountcoupon'><input type="text" name="" id="" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} onKeyDown={(e) => resendhandleKeypress(e)}/>
                           
                                <button type="submit" className="btn default_button" onClick={() => ApplyCoupons()} >Apply</button>
                               
                            </div>
                            <span style={{color:"red"}}>{invalidCoupan}</span>
                        </>
                    )}
                        
                </div>
                
               
                {/* <div className="coupon_option">
                    <label><i className="fa fa-gift"><FaGift /></i>Add Gift Certificate</label>
                    <form action=""><input type="text" name="" id="" /><button className="couponCheck">Add</button></form>
                </div> */}

                <div className="cart_subtotal_block">
                    <ul>
                        <li>
                            <div className='amount-div'>
                            <label for="">Price   <span>{countItemsInCart()}</span>
                            </label>
                            <br/>
                            <span>(Incl. of all taxes)</span>
                            </div>
                            <span>{getSampleCurrencyFormat("INR", cartPrices && cartPrices && cartPrices.subtotal_including_tax && cartPrices.subtotal_including_tax.value ? cartPrices && cartPrices && cartPrices.subtotal_including_tax && cartPrices.subtotal_including_tax.value : "0")}</span>
                            {/* <span> {getTotalAmount()}</span> */}
                        </li>
                        {/* <li>
                            <label for="">Total Discount</label>
                            <span>
                                {getTotaltDiscount()}
                            </span>
                        </li> */}
                        <li>
                            <label for="">Coupon Discount</label>
                            <span>
                                {getProductDiscount()}
                            </span>
                        </li>
                        {addtoproductcart[0] ? (
                            <li>
                                <label for="">Delivery Charges</label>
                                <span>{getShippingAmount()}</span>
                            </li>
                        ) : (
                            <></>
                        )}
                        <li>
                        <div className='amount-div'>

                            <label for="">Total Amount</label>
                            <br/>
                            <span>(Incl. of all taxes)</span>
                            </div>
                            <span> {getSampleCurrencyFormat("INR", cartPrices && cartPrices && cartPrices.grand_total && cartPrices.grand_total.value ? cartPrices && cartPrices && cartPrices.grand_total && cartPrices.grand_total.value : "0")}</span>
                            
                        </li>
                      
                        {/* <li className="gst_saving_info">
                        <label for="">Additional GST Benefit for business customers.</label>
                        <span> {getSampleCurrencyFormat("INR", cartPrices && cartPrices && cartPrices.grand_total && cartPrices.grand_total.value ? (cartPrices && cartPrices && cartPrices.grand_total && cartPrices.grand_total.value * 18/100) : "0")}</span>

                        </li> */}
                       {landingData.company[0].cartpage_text &&
                        <li className="saving_info">
                        <p dangerouslySetInnerHTML={{ __html: landingData.company[0].cartpage_text }}></p>
                        </li>
                        }
                      
                        {/* <li className="saving_info">
                            You will save  {getProductDiscount()} on this order
                        </li> */}
                    </ul>
                    {addtoproductcart.length ? 
                    <div className="procede_cart">
                      
                      <div className="proceede_btn">
                          <button className="btn default_button" onClick={()=>errorCheckout()}>Checkout</button>
                      </div>
                  </div> : null}
                </div>
            </div>


            {loader && (
                <div className='loading-overlay'>
                    <div className='bounce-loader'>
                        {/* <div className='bounce1'></div>
								<div className='bounce2'></div>
								<div className='bounce3'></div> */}
                        <div className="loader"></div>
                    </div>
                </div>
            )}
        </>
    )
}
export default CartRightBlock;